import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Card, Table, Badge, Button } from "react-bootstrap";
import { GRADIENTS } from "utils/theme";
import Useaxios from "utils/Useaxios";
import { API } from "utils/Apiroutes";
import usePagination from "hooks/usePagination";
import Pagination from "components/ui/Pagination";
import TableFilter from "components/ui/TableFilter";
import {
  getGlobalCurrency,
  convertPrice,
  setExchangeRate
} from "../utils/currency.js";
import CurrencyDropdown from "./ui/CurrencyDropdown.js";
import { Search } from "lucide-react";
import './transaction.css'
import { useLocation } from "react-router";

const isPendingPage = ()=>{
  return window.location.pathname === "/admin/transactions/pending"

}
// Add CSS animations
const styles = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .item-count-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  
  .item-count-btn:hover {
    transform: scale(1.05) !important;
    box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3) !important;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

function Transactions() {
  const { fetchData } = Useaxios();
  const [expandedTransaction, setExpandedTransaction] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const rout = useLocation().pathname
  const [datastats, setStats] = useState({
    totalTransactions: "",
    successful: "",
    pending: "",
    totalRevenue: ""

  })
  console.log(rout)

  const [selectedCurrency, setSelectedCurrency] = useState(getGlobalCurrency());
  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const res = await fetchData({
          url: API.getExchangeRate,
          method: "GET",
          showMessage: false
        });

        if (res?.success && res?.data?.exchangeRate) {
          setExchangeRate(Number(res.data.exchangeRate));
        } else {
          setExchangeRate(1);
        }

      } catch (error) {
        console.error("Failed to fetch exchange rate", error);
        setExchangeRate(1);
      }
    };

    fetchExchangeRate();
  }, []);

  useEffect(() => {
    const handleCurrencyChange = () => {
      setSelectedCurrency(getGlobalCurrency());
    };

    window.addEventListener("currencyChanged", handleCurrencyChange);

    return () => {
      window.removeEventListener("currencyChanged", handleCurrencyChange);
    };
  }, []);

  const fetchTransactions = useCallback(async (params) => {
    const res = await fetchData({
      url: API.getTransactions,
      method: 'GET',
      params,
      showMessage: false
    });
    if (res.success) {
      setStats(res.data.globalStats)
    }
    return res;
  }, [rout]);


  const {
    data: transactions,
    loading,
    currentPage,
    totalPages,
    totalItems,
    pageSize,
    filters,
    goToPage,
    nextPage,
    prevPage,
    changePageSize,
    updateFilters,
    clearFilters
  } = usePagination(fetchTransactions, { search: '', status: "", });



  useEffect(() => {
    if (rout == "/admin/transactions/pending") {

      updateFilters({ status: "PENDING" })
    } else {
      updateFilters({ status: "" })
    }
  }, [rout])
  const getTransactionStats = () => {

    if (!transactions || !Array.isArray(transactions)) {
      return { success: 0, pending: 0, total: 0, totalAmount: 0 };
    }

    const success = transactions.filter(t => t.status === "SUCCESSFUL").length;
    const pending = transactions.filter(t => t.status === "PENDING").length;

    const totalAmount = transactions.reduce(
      (sum, t) => sum + (t.totalAmount || 0),
      0
    );

    return {
      success,
      pending,
      total: transactions.length,
      totalAmount
    };
  };

  const stats = getTransactionStats();

  const filterFields = [
    {
      key: 'search',
      label: 'Search',
      type: 'text',
      placeholder: 'Search by Machine ID or Transaction ID...'
    },

  ];
  if (rout !== "/admin/transactions/pending") {
    filterFields.push({
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        // { value: '', label: 'All Status' },
        { value: 'SUCCESSFUL', label: 'SUCCESSFUL' },
        { value: 'PENDING', label: 'PENDING' },
        { value: 'FAILED', label: 'FAILED' }
      ]
    })
  }



  const formatStatus = (status) => {
    return status
      .toLowerCase()
      .replace("_", " ")
      .replace(/\b\w/g, c => c.toUpperCase());
  };
  const getStatusVariant = (status) => {
    switch (status.toLowerCase()) {
      case "successful":
      case "success":
        return "success";   // green

      case "pending":
        return "warning";   // yellow

      case "failed":
        return "danger";    // red

      case "processing":
        return "info";      // blue

      case "cancelled":
        return "secondary"; // grey

      default:
        return "dark";
    }
  };

  return (
    <Container fluid className="py-4">
      <Row>
        <Col md="12">
          <Card className="shadow border-0 rounded-3 overflow-hidden">
            <div style={{ background: GRADIENTS.primary }} className="text-white py-3 px-4">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="mb-0 fw-semibold" style={{ fontSize: 'clamp(1rem, 4vw, 1.5rem)' }}>
                    <i className="fas fa-receipt me-2"></i>
                    <span className="d-none d-sm-inline">Transactions Management</span>
                    <span className="d-inline d-sm-none">Transactions</span>
                  </h4>
                  <p className="mb-0 opacity-75 mt-1 d-none d-md-block" style={{ fontSize: '0.9rem' }}>
                    Monitor all vending machine transactions
                  </p>
                </div>

                {/* ✅ RIGHT SIDE CONTROLS */}
                <div className="d-flex gap-2 align-items-center">

              

                  <Button
                    variant="light"
                    size="sm"
                    onClick={() => setShowFilters(!showFilters)}
                    className="fw-medium d-flex align-items-center"
                  >
                    <i className="fas fa-filter me-1"></i>
                    <span className="d-none d-md-inline">Filters</span>
                    {Object.values(filters).filter(v => v).length > 0 && (
                      <Badge bg="danger" className="ms-2">
                        {Object.values(filters).filter(v => v).length}
                      </Badge>
                    )}
                  </Button>

                </div>
              </div>
            </div>

            {showFilters && (
              <div className="px-4 pt-3 border-bottom">
                <TableFilter
                  filterConfig={filterFields}
                  filters={filters}
                  onFilterChange={updateFilters}
                  onClearFilters={clearFilters}
                />
              </div>
            )}

            <Card.Body className="p-0">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3 text-muted">Loading transactions...</p>
                </div>
              ) : !transactions || transactions.length === 0 ? (
                <div className="text-center py-5">
                  <div className="display-1 text-muted mb-3 opacity-50">
                    <i className="fas fa-receipt"></i>
                  </div>
                  <h4 className="text-muted mb-3">No Transactions Found</h4>
                  <p className="text-muted mb-4">No transaction data available</p>
                </div>
              ) : (
                <>
                  {/* Statistics Cards */}
                  <div className="p-4 bg-light border-bottom">
                    <Row className="g-3">
                      <Col md={3}>
                        <div className="stat-card">
                          <div className="d-flex align-items-center">
                            <div className="stat-icon bg-primary bg-opacity-10 text-primary rounded-circle p-3 me-3">
                              <i className="fas fa-receipt fa-lg"></i>
                            </div>
                            <div>
                              <h3 className="fw-bold mb-0">{datastats?.totalTransactions}</h3>
                              <small className="text-muted">Total Transactions</small>
                            </div>
                          </div>
                        </div>
                      </Col>
                      {
                        !isPendingPage() && <Col md={3}>
                        <div className="stat-card">
                          <div className="d-flex align-items-center">
                            <div className="stat-icon bg-success bg-opacity-10 text-success rounded-circle p-3 me-3">
                              <i className="fas fa-check-circle fa-lg"></i>
                            </div>
                            <div>
                              <h3 className="fw-bold mb-0">{datastats?.successful}</h3>
                              <small className="text-muted">Successful</small>
                            </div>
                          </div>
                        </div>
                      </Col>

                      }
                      
                      <Col md={3}>
                        <div className="stat-card">
                          <div className="d-flex align-items-center">
                            <div className="stat-icon bg-warning bg-opacity-10 text-warning rounded-circle p-3 me-3">
                              <i className="fas fa-clock fa-lg"></i>
                            </div>
                            <div>
                              <h3 className="fw-bold mb-0">{datastats?.pending}</h3>
                              <small className="text-muted">Pending</small>
                            </div>
                          </div>
                        </div>
                      </Col>
                      {
                        !isPendingPage() && <Col md={3}>
                        <div className="stat-card">
                          <div className="d-flex align-items-center">
                            <div className="stat-icon bg-info bg-opacity-10 text-info rounded-circle p-3 me-3">
                              <i className="fas fa-dollar-sign fa-lg"></i>
                            </div>
                            <div>
                              <h3>
                                {selectedCurrency}{" "}
                                {convertPrice(datastats.totalRevenue, "LRD").toFixed(2)}
                              </h3>
                              <small className="text-muted">Total Revenue</small>
                            </div>
                          </div>
                        </div>
                      </Col>
                      }
                      
                    </Row>
                  </div>

                  {/* Transactions Table */}
                  <div className="table-responsive">
                    <Table hover className="mb-0 align-middle">
                      <thead className="bg-light">
                        <tr>
                          <th className="border-0 ps-4 transactionheader transactionIdheader "  >Transaction ID</th>
                          <th className="border-0 transactionheader machineIdHeader"   >Machine ID</th>
                          <th className="border-0 transactionheader productIdHeader " >Product</th>
                          <th className="border-0 text-center transactionheader qntyHeader " >Qty</th>
                          <th className="border-0 text-end transactionheader  amounheader" >Amount</th>
                          <th className="border-0 text-end transactionheader taxheader " >Tax</th>
                          <th className="border-0 text-end transactionheader totalheader" >Total</th>
                          <th className="border-0 text-center transactionheader statusheader" >Status</th>
                          <th className="border-0 transactionheader payementheader" >Payment</th>
                          <th className="border-0 pe-4 transactionheader dateheader" >Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactions && transactions.map((transaction) => {
                          const isExpanded = expandedTransaction === transaction._id;
                          const toggleExpanded = () => {
                            setExpandedTransaction(isExpanded ? null : transaction._id);
                          };

                          return (
                            <React.Fragment key={transaction._id}>
                              <tr className="align-middle">
                                <td className="ps-4">
                                  <div className="d-flex align-items-center">
                                    <div className="transaction-icon bg-primary bg-opacity-10 text-primary rounded-circle p-2 me-3">
                                      <i className="fas fa-receipt"></i>
                                    </div>
                                    <div>
                                      <h6 className="mb-0 fw-semibold">{transaction.transactionId}</h6>

                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <i className="fas fa-robot text-muted me-2"></i>
                                    <span className="fw-semibold">{transaction.machineId}</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="item-count-btn d-flex align-items-center px-3 py-2 rounded-pill bg-primary bg-opacity-10 text-primary"
                                      style={{
                                        cursor: 'pointer',
                                        border: '2px solid transparent',
                                        background: isExpanded ? 'rgba(13, 110, 253, 0.15)' : 'rgba(13, 110, 253, 0.1)'
                                      }}
                                      onClick={toggleExpanded}
                                    >
                                      <i className="fas fa-layer-group me-2" style={{ fontSize: '0.9rem' }}></i>
                                      <span className="fw-bold">{transaction.items.length}</span>
                                      <span className="ms-1 fw-medium" style={{ fontSize: '0.85rem' }}>items</span>
                                      <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'} ms-2`} style={{
                                        fontSize: '0.75rem',
                                        transition: 'transform 0.3s ease',
                                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
                                      }}></i>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">
                                  <Badge bg="secondary" className="rounded-pill">
                                    {transaction.items.reduce((total, item) => total + item.qty, 0)}
                                  </Badge>
                                </td>
                                <td className="text-end">
                                  <span className="fw-semibold">${selectedCurrency}{" "}
                                    {convertPrice(transaction.amount, transaction.currencyType || "LRD").toFixed(2)}</span>
                                </td>
                                <td className="text-end">
                                  <span className="text-muted">
                                    {selectedCurrency}{" "}
                                    {convertPrice(
                                      transaction.taxAmount,
                                      transaction.currencyType || "LRD"
                                    ).toFixed(2)}
                                  </span>                                </td>
                                <td className="text-end">
                                  <span className="fw-bold text-success">
                                    {selectedCurrency}{" "}
                                    {convertPrice(
                                      transaction.totalAmount,
                                      transaction.currencyType || "LRD"
                                    ).toFixed(2)}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <Badge
                                    bg={getStatusVariant(transaction.status)}
                                    className="rounded-pill px-3 py-2 d-inline-flex align-items-center gap-1"
                                  >
                                    <i className="fas fa-circle" style={{ fontSize: '0.45rem' }}></i>
                                    {formatStatus(transaction.status)}
                                  </Badge>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <i className="fas fa-credit-card text-muted me-2"></i>
                                    <span className="text-capitalize">{transaction.paymentMethod}</span>
                                  </div>
                                  {transaction.momoRef && (
                                    <small className="text-muted d-block">Ref: {transaction.momoRef.slice(-8)}</small>
                                  )}
                                </td>
                                <td className="pe-4">
                                  <div>
                                    <span className="fw-medium">{new Date(transaction.createdAt).toLocaleDateString()}</span>
                                    <small className="text-muted d-block">{new Date(transaction.createdAt).toLocaleTimeString()}</small>
                                  </div>
                                </td>
                              </tr>
                              {
                                isExpanded && (
                                  <tr style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
                                    <td colSpan="10" className="p-0">
                                      <div style={{
                                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                        borderTop: '2px solid #dee2e6',
                                        borderLeft: '4px solid #0d6efd'
                                      }}>
                                        <div className="p-4">
                                          {/* <div className="d-flex align-items-center mb-4">
                                            <div className="bg-primary text-white rounded-circle p-2 me-3" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                              <i className="fas fa-shopping-cart"></i>
                                            </div>
                                            <div>
                                              <h5 className="mb-0 fw-bold text-dark">Items in this Transaction</h5>
                                              <small className="text-muted">Transaction ID: {transaction._id.slice(-8)}</small>
                                            </div>
                                          </div> */}

                                          {/* YEH LINE CHANGE KI HAI - ab sirf 3 boxes per line honge */}
                                          <div className="row g-3">
                                            {transaction.items.map((item, index) => (
                                              <div key={index} className="col-xl-4 col-lg-4 col-md-6">
                                                <div className="card h-100 border-0" style={{
                                                  background: 'white',
                                                  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                  borderRadius: '10px',
                                                  transition: 'all 0.3s ease',
                                                  border: '1px solid #e9ecef'
                                                }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                                                    e.currentTarget.style.borderColor = '#0d6efd';
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                                                    e.currentTarget.style.borderColor = '#e9ecef';
                                                  }}>
                                                  <div className="card-body p-3">
                                                    {/* Product Header */}
                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                      <div className="d-flex align-items-center">
                                                        <div className="bg-success bg-opacity-10 text-success rounded-circle me-2" style={{
                                                          width: '35px',
                                                          height: '35px',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent: 'center',
                                                          fontSize: '14px'
                                                        }}>
                                                          <i className="fas fa-cookie-bite"></i>
                                                        </div>
                                                        <div>
                                                          <h6 className="mb-0 fw-bold text-dark" style={{ fontSize: '14px', lineHeight: '1.2' }}>
                                                            {item.productId.name}
                                                          </h6>
                                                        </div>
                                                      </div>
                                                      <Badge bg="primary" className="rounded-pill px-2 py-1" style={{ fontSize: '11px', fontWeight: '600' }}>
                                                        ×{item.qty}
                                                      </Badge>
                                                    </div>

                                                    {/* Pricing Details */}
                                                    <div className="border-top pt-3">
                                                      <div className="row g-0 mb-2">
                                                        <div className="col-6">
                                                          <small className="text-muted fw-medium">Unit Price:</small>
                                                        </div>
                                                        <div className="col-6 text-end">
                                                          <span className="fw-semibold text-success" style={{ fontSize: '13px' }}>${selectedCurrency}{" "}
                                                            {convertPrice(item.finalPrice, item.currencyType || "LRD").toFixed(2)}</span>
                                                        </div>
                                                      </div>
                                                      <div className="row g-0">
                                                        <div className="col-6">
                                                          <small className="text-muted fw-medium">Subtotal:</small>
                                                        </div>
                                                        <div className="col-6 text-end">
                                                          <span className="fw-bold text-primary" style={{ fontSize: '14px' }}>${selectedCurrency}{" "}
                                                            {convertPrice(item.finalPrice * item.qty, item.currencyType || "LRD").toFixed(2)}</span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>

                                          {/* Transaction Summary */}
                                          <div className="mt-4 p-3 bg-white rounded-3 border">
                                            <div className="row g-3 text-center">
                                              <div className="col-md-3">
                                                <div className="d-flex flex-column">
                                                  <span className="text-muted small">Total Items</span>
                                                  <span className="fw-bold text-primary h5 mb-0">{transaction.items.length}</span>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="d-flex flex-column">
                                                  <span className="text-muted small">Total Quantity</span>
                                                  <span className="fw-bold text-info h5 mb-0">{transaction.items.reduce((total, item) => total + item.qty, 0)}</span>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="d-flex flex-column">
                                                  <span className="text-muted small">Subtotal</span>
                                                  <span className="fw-bold text-warning h5 mb-0">${selectedCurrency}{" "}
                                                    {convertPrice(transaction.taxAmount, transaction.currencyType || "LRD").toFixed(2)}</span>
                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <div className="d-flex flex-column">
                                                  <span className="text-muted small">Final Total</span>
                                                  <span className="fw-bold text-success h5 mb-0">${selectedCurrency}{" "}
                                                    {convertPrice(transaction.totalAmount, transaction.currencyType || "LRD").toFixed(2)}</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              }
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </>
              )}
            </Card.Body>

            {transactions && transactions.length > 0 && (
              <Card.Footer className="bg-light border-0 py-3 px-4">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalItems={totalItems}
                  pageSize={pageSize}
                  onPageChange={goToPage}
                  onNextPage={nextPage}
                  onPrevPage={prevPage}
                  onPageSizeChange={changePageSize}
                />
              </Card.Footer>
            )}
          </Card>
        </Col>
      </Row>
    </Container >
  );
}

export default Transactions;